import React, { useEffect, useState } from 'react';
import { Subject } from '../types/question';
import { curriculumService } from '../services/curriculumService';
import { Box, Typography, CircularProgress, Alert } from '@mui/material';
import { TreeView, TreeItem } from '@mui/lab';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

export default function CurriculumPage() {
  const [subjects, setSubjects] = useState<Subject[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSubjects = async () => {
      try {
        const data = await curriculumService.getSubjects();
        setSubjects(data);
      } catch (err) {
        setError('Failed to load curriculum structure');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSubjects();
  }, []);

  const renderTree = (nodes: Subject) => (
    <TreeItem
      key={nodes.id}
      nodeId={nodes.id}
      label={nodes.name}
    >
      {Array.isArray(nodes.strands) ? nodes.strands.map((strand) => (
        <TreeItem
          key={strand.id}
          nodeId={strand.id}
          label={strand.name}
        >
          {Array.isArray(strand.substrands) ? strand.substrands.map((substrand) => (
            <TreeItem
              key={substrand.id}
              nodeId={substrand.id}
              label={substrand.name}
            />
          )) : null}
        </TreeItem>
      )) : null}
    </TreeItem>
  );

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={3}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Curriculum Structure
      </Typography>
      <TreeView
        defaultCollapseIcon={<ExpandMoreIcon />}
        defaultExpandIcon={<ChevronRightIcon />}
      >
        {subjects.map((subject) => renderTree(subject))}
      </TreeView>
    </Box>
  );
} 